var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',{staticClass:"actions-bar pa-4 bar-shadow primary-background"},[_c('EmployeesFilter')],1),_c('v-row',{staticClass:"pa-4"},[_c('v-col',[_c('v-card',[_c('EmployeesTable')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }